/**=========================================================
 * Module: perm.js
 * Permission service
 =========================================================*/

App.service('Perm', function($rootScope, $api, $q, authService, authServiceHelpers, toaster, $window, $cookies, responseHelper, SERVER_BASE_URL){
    perm_promise_deferred = $q.defer()
    let bootMeClaimed = false
    const requestMe = () => $api('GET', '/me', { lean: true })
    const fetchMe = () => {
      const boot = !bootMeClaimed && $window.__NH_BOOT__ && $window.__NH_BOOT__.me
      bootMeClaimed = true
      const subdomain = authServiceHelpers.getUserSubdomain()
      if (!boot || boot.url !== `${SERVER_BASE_URL}/me${typeof subdomain == 'undefined' ? '?lean=true' : `?subdomain=${subdomain}&lean=true`}`) {
        return requestMe()
      }

      return $q.when(boot.response)
        .then(response => response.ok ? response.clone().json().then(data => ({ data, status: response.status })) : $q.reject())
        .catch(requestMe)
    }
    const PROVIDER_META_TYPES = ['Dentist', 'Doctor', 'Hygienist', 'MedicalAssistant', 'NursePractitioner', 'PhysicianAssistant', 'Provider', 'Unknown']
    const responseData = response => response.data && response.data.code ? response.data.data : $q.reject(response)
    const settle = promise => promise.then(value => ({ value }), error => ({ error }))
    const fetchLocations = () => $api('GET', '/locations', { for_current_user: true }).then(responseData)
    const colleagueRequests = {}
    const fetchColleagues = (locationId) => {
      const key = locationId || 'all'
      if (!colleagueRequests[key]) {
        colleagueRequests[key] = $api('GET', '/providers', locationId ? { location_id: locationId } : {})
          .then(responseData)
          .then(providers => {
            const userLocationIds = _.map(perm.locations, 'id')
            const colleagues = _.filter(providers, p =>
              PROVIDER_META_TYPES.indexOf(p.meta_type) != -1 &&
              ($rootScope.embedded || String(p.id) != String(perm.myself.id)) &&
              (locationId || _.some(p.locations, l => userLocationIds.indexOf(l.id) != -1))
            )
            if(perm.myself.meta_type != 'Doctor'){
              _.each(colleagues, c => { c.isChecked = false })
            }
            return colleagues
          })
          .catch(response => {
            delete colleagueRequests[key]
            responseHelper.checkError(response || {})
            return []
          })
      }
      return colleagueRequests[key]
    }
    var perm = {
      perm_promise: perm_promise_deferred.promise,
      permtypes: ['edit_settings', 'edit_profile', 'schedule', 'get_notifs', 'view_patients', 'charge', 'message', 'sync', 'surveys', 'campaigns', 'analytics','forms'],
      permission_levels: { none: 0, view: 1, edit: 2, manage: 3, admin: 4 },
      authz_permissions: {},
      myself: {},
      updateMyself: () => {
        perm.myself = {
          id: authService.getUserId(),
          name: authService.getUserName(),
          meta_type: authService.getUserType(),
          min_appt_length: authService.getMinApptLength(),
          patientable: authService.isPatientable(),
          isChecked: false
        }
      },
      loadLocation: (locationId) => $api('GET', `/locations/${locationId}`, { include: ['operatories'] }).then(responseData),
      getConnections: () => {
        perm.updateMyself()
        const locationsRequest = $rootScope.embedded ? null : settle(fetchLocations())
        fetchMe().then( (d,s) => {
          const z = d.data.data
          const defaultLocationId = z && z.location_id

          if (z) {
            // prevent overriding selected location_id
            z.location_id = authService.getLocationId() || z.location_id
          }
          responseHelper.willStoreCookie({ $response: d })

          if(z == null || z.user.meta_type == 'Patient') {
            $rootScope.logOut()
            return false
          }

          const locationsResult = $rootScope.embedded ? $q.when({ value: z.locations }) : locationsRequest
          return locationsResult.then(({ value: locations, error }) => {
            if (error) {
              $rootScope.loaderror = true
              return false
            }

            if(
              !z.incomplete_onboarding &&
              !$rootScope.impersonationSessionId &&
              !$rootScope.impersonated &&
              !z.institution.is_client_live &&
              locations.length === 0
            ) {
              $rootScope.logOut()
              return false
            }

            perm.authz_permissions = (z.authz && z.authz.permissions) || {}
            $rootScope.user = z.user
            $rootScope.user.is_nexhealth_staff = !!($rootScope.user.email.match(/.*@nexhealth.com$/))

            perm.institution = z.institution
            perm.is_inst_admin = z.is_institution_admin === true
            perm.locations = locations
            const findLocation = id => _.find(locations, {id: parseInt(id)})
            if ($rootScope.embedded) {
              locationFromUrl = findLocation(authServiceHelpers.getLocationId())
              if (!locationFromUrl) {
                toaster.pop('error', 'Error', "You don't have permission to access this location" )
                throw new Error("You don't have permission to access this location")
              }
              perm.default_location = locationFromUrl
            } else {
              perm.default_location = findLocation($cookies.get('location_id')) ||
                ($rootScope.location && findLocation($rootScope.location.id)) ||
                findLocation(defaultLocationId) ||
                locations[0]
            }

            if ($rootScope.embedded || !perm.default_location) {
              return perm.default_location
            }
            return perm.loadLocation(perm.default_location.id).then(location => {
              locations[locations.indexOf(perm.default_location)] = location
              return location
            })
          }).then(location => {
            if (location === false) {
              return
            }

            $rootScope.locations = perm.locations
            $rootScope.locationhash = _.keyBy(perm.locations, 'id')

            perm.set_inst(perm.institution)

            if (location) {
              perm.set_loc(location, true)
            }

            perm_promise_deferred.resolve(true)
            $rootScope.apploaded = true
          }, () => {
            $rootScope.loaderror = true
          })
        }, (d,s) => {
          $rootScope.loaderror = true
        })
      },
      set_inst: (inst) => {
        perm.institution = inst
        $rootScope.is_inst_admin = perm.is_inst_admin
        $rootScope.institution = inst
        $rootScope.$broadcast('inst_change', inst)
      },
      set_loc: (loc, nobc) => {
        perm.default_location = loc
        $rootScope.location = loc
        setTimezone()
        const channel = new BroadcastChannel("locationChange");
        channel.postMessage(loc.id);
        if (heap && heap.clearEventProperties && heap.addEventProperties) {
          heap.clearEventProperties();
          heap.addEventProperties({
            LocationId: loc.id,
            InstitutionId: $cookies.get('institution_id'),
            InstitutionSlug: $cookies.get('subdomain'),
            Impersonated: $rootScope.impersonated,
          })
        }
        authService.setCookie({ location_id: loc.id })
        if(!nobc){
          $rootScope.$broadcast('loc_change', loc)
        }
      },
      friends: (opts = {}) => perm.perm_promise.then(() => {
        if (opts.all_locations) {
          return fetchColleagues(null)
        }
        const locationIds = _.castArray(opts.location_id || ($rootScope.location && $rootScope.location.id)).filter(Boolean)
        return $q.all(_.map(locationIds, fetchColleagues)).then(_.flatten)
      }).then(colleagues => {
        var base = opts.no_self ? colleagues : [perm.myself].concat(colleagues)
        base = _.filter(base, c => c.patientable)
        if(!opts.no_sort){
          base = _.sortBy(base, c => c.id != perm.myself.id)
        }
        if(opts.dup){
          base = angular.copy(base)
        }

        const result = {result: _.uniqBy(base, 'id')}
        if(opts.ids){
          result.ids = _.map(result.result, 'id')
        }
        return result
      }),
      can_access_tab: (user_permission, inst_privilege = false) => {
        // The react app handles permissions now.
        return true
      },
      has_permission: (action) => {
        const parts = (action || '').split(':')
        const resource = parts[0]
        const required_level = parts[1]
        const user_level = perm.authz_permissions[resource]
        const user_level_integer = perm.permission_levels[user_level] || 0
        const required_level_integer = perm.permission_levels[required_level]
        return required_level_integer !== undefined && user_level_integer >= required_level_integer
      },
      admin_at_current_inst: () => perm.is_inst_admin
    }

    setTimezone = () => {
      var timezone
      if ($rootScope.location && $rootScope.location.tz) {
        timezone = $rootScope.location.tz
      }
      if (angular.isUndefined(timezone) && $rootScope.institution && $rootScope.institution.tz) {
        timezone = $rootScope.institution.tz
      }
      $rootScope.timezone = timezone
    }

    return perm
})
